module.exports = __webpack_public_path__ + "static/media/rmc.df93daad.png";